<div class="fleets-container">
  <!-- Sticky Header: Sub Tabs -->
  <div class="fleets-sticky-header">
    <!-- Sub Tabs -->
    <div class="tabs-inner-wrapper">
      <div class="sub-tabs">
        <button class="sub-tab" [appTourAnchor]="'fleets.discoverTab'" [class.active]="activeTab === 'find'" (click)="setActiveTab('find')">
          Find
        </button>
        <button class="sub-tab" [appTourAnchor]="'fleets.myTab'" [class.active]="activeTab === 'my-fleets'" (click)="setActiveTab('my-fleets')">
          My Fleets
        </button>
        <button class="sub-tab" [appTourAnchor]="'fleets.incomingTab'" [class.active]="activeTab === 'incoming'" (click)="setActiveTab('incoming')">
          Incoming
          <span class="badge" *ngIf="activeTab === 'incoming' && incomingCount > 0">{{
            incomingCount < 10 ? "0" + incomingCount : incomingCount }}</span>
        </button>
        <button class="sub-tab" [appTourAnchor]="'fleets.sentTab'" [class.active]="activeTab === 'sent'" (click)="setActiveTab('sent')">
          Sent
          <span class="badge" *ngIf="activeTab === 'sent' && sentCount > 0">{{
            sentCount < 10 ? "0" + sentCount : sentCount }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="fleets-content-wrapper">
    <!-- Title & Search Bar Row (scrolls with the cards, inside the card) -->
    <div class="header-action-row">
      <div class="search-bar" [appTourAnchor]="'fleets.search'">
        <img class="search-icon" src="assets/home/profile/searchicon.svg" />
        <input *ngIf="activeTab === 'find'" type="text" [placeholder]="getSearchPlaceholder()" [(ngModel)]="searchFind"
          (ngModelChange)="onSearchInput($event)" />
        <input *ngIf="activeTab === 'my-fleets'" type="text" [placeholder]="getSearchPlaceholder()"
          [(ngModel)]="searchMyFleets" (ngModelChange)="onSearchInput($event)" />
        <input *ngIf="activeTab === 'incoming'" type="text" [placeholder]="getSearchPlaceholder()"
          [(ngModel)]="searchIncoming" (ngModelChange)="onSearchInput($event)" />
        <input *ngIf="activeTab === 'sent'" type="text" [placeholder]="getSearchPlaceholder()" [(ngModel)]="searchSent"
          (ngModelChange)="onSearchInput($event)" />
      </div>
    </div>

    <!-- ============ Find Tab Content ============ -->
    <div class="fleets-list find-grid" [appTourAnchor]="'fleets.list'" *ngIf="activeTab === 'find'">

      <!-- Skeleton: initial load -->
      <ng-container *ngIf="loading && fleets.length === 0">
        <div class="fleet-discovery-card skeleton-card" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="card-photo"></div>
          <div class="card-body">
            <span class="skeleton-line skeleton-shimmer" style="width: 65%; height: 18px;"></span>
            <span class="skeleton-line skeleton-shimmer" style="width: 45%; height: 12px; margin-top: 10px;"></span>
            <span class="skeleton-line skeleton-shimmer" style="width: 35%; height: 12px; margin-top: 8px;"></span>
            <div class="skeleton-stats-row">
              <span class="skeleton-stat skeleton-shimmer"></span>
              <span class="skeleton-stat skeleton-shimmer"></span>
              <span class="skeleton-stat skeleton-shimmer"></span>
            </div>
            <span class="skeleton-line skeleton-shimmer" style="width: 100%; height: 36px; margin-top: 12px; border-radius: 8px;"></span>
          </div>
        </div>
      </ng-container>

      <div class="fleet-discovery-card" *ngFor="let fleet of fleets" (click)="viewGroupForFind(fleet)">
        <!-- Photo at top -->
        <div class="card-photo">
          <img *ngIf="fleet.image_url" [src]="fleet.image_url" class="photo-img" />
          <div *ngIf="!fleet.image_url" class="photo-initials">
            {{ getInitials(fleet.name) }}
          </div>
        </div>

        <!-- Card body -->
        <div class="card-body">
          <h3 class="fleet-name">{{ fleet.name }}</h3>
          <div class="fleet-org">
            <img class="org-icon" src="assets/home/profile/boaticon.svg" />
            {{ fleet.home_port || 'No vessel' }}
          </div>
          <span class="member-count">{{ fleet.members_count }} {{ fleet.members_count <= 1 ? 'member' : 'members' }}</span>

          <!-- Stats Row -->
          <div class="stats-row">
            <div class="stat-item">
              <span class="label">{{ (fleet.activity?.routes || 0) <= 1 ? 'Route' : 'Routes' }}</span>
              <span class="value">{{ fleet.activity?.routes || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="label">Fish Caught</span>
              <span class="value">{{ fleet.activity?.fish_caught || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="label">{{ (fleet.activity?.places || 0) <= 1 ? 'Place' : 'Places' }}</span>
              <span class="value">{{ fleet.activity?.places || 0 }}</span>
            </div>
          </div>

          <!-- Actions -->
          <div class="actions-row">
            <button *ngIf="fleet.request_status === 'accepted'" class="joined-btn" (click)="$event.stopPropagation()">
              <mat-icon class="joined-tick" *ngIf="fleet.my_role !== 'owner' && fleet.my_role !== 'admin'">check_circle</mat-icon>
              <mat-icon class="admin-icon-btn" *ngIf="fleet.my_role === 'owner' || fleet.my_role === 'admin'">person</mat-icon>
              {{ (fleet.my_role === 'owner' || fleet.my_role === 'admin') ? 'Admin' : 'Joined' }}
            </button>
            <button *ngIf="fleet.request_status === 'pending'" class="pending-btn" (click)="$event.stopPropagation()">
              <mat-icon class="pending-timer">schedule</mat-icon>
              Request Sent
            </button>
            <button *ngIf="!fleet.request_status && fleet.privacy === 'public'" class="join-btn"
              [disabled]="fleet.actionLoading" (click)="requestToJoin(fleet); $event.stopPropagation()">
              <span *ngIf="fleet.actionLoading" class="btn-spinner"></span>
              <span *ngIf="!fleet.actionLoading">Join</span>
            </button>
            <button *ngIf="!fleet.request_status && fleet.privacy !== 'public'" class="request-btn"
              [disabled]="fleet.actionLoading" (click)="requestToJoin(fleet); $event.stopPropagation()">
              <span *ngIf="fleet.actionLoading" class="btn-spinner"></span>
              <ng-container *ngIf="!fleet.actionLoading">
                <img src="/assets/common_icons/lock_icon.svg" class="lock-icon" />
                Request
              </ng-container>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!loading && fleets.length === 0" class="no-data">
        <ng-container *ngIf="searchFind; else noFindDefault">
          <mat-icon class="no-data-icon">search_off</mat-icon>
          <span>No fleets found for "{{ searchFind }}"</span>
          <button class="clear-search-btn" (click)="clearSearch()">Clear Search</button>
        </ng-container>
        <ng-template #noFindDefault>No fleets found</ng-template>
      </div>

      <!-- Skeleton: infinite scroll -->
      <div class="fleet-discovery-card skeleton-card" *ngIf="loading && fleets.length > 0">
        <div class="card-photo"></div>
        <div class="card-body">
          <span class="skeleton-line skeleton-shimmer" style="width: 65%; height: 18px;"></span>
          <span class="skeleton-line skeleton-shimmer" style="width: 45%; height: 12px; margin-top: 10px;"></span>
        </div>
      </div>
    </div>

    <!-- Create Button (Sticky/Fixed Position) -->
    <div class="create-fleet-container" *ngIf="isProfileOpen && (activeTab === 'find' || activeTab === 'my-fleets')">
      <button class="create-btn" (click)="openCreateFleet()">
        <span class="plus-icon">+</span> Create
      </button>
    </div>

    <!-- ============ My Fleets Tab Content ============ -->
    <div class="fleets-list my-fleets-grid" [appTourAnchor]="'fleets.list'" *ngIf="activeTab === 'my-fleets'">

      <!-- Skeleton: initial load -->
      <ng-container *ngIf="loading && fleets.length === 0">
        <div class="my-fleet-card skeleton-card" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="card-photo"></div>
          <div class="card-body">
            <span class="skeleton-line skeleton-shimmer" style="width: 65%; height: 18px;"></span>
            <span class="skeleton-line skeleton-shimmer" style="width: 45%; height: 12px; margin-top: 10px;"></span>
            <div class="meta-row" style="margin-top: 8px;">
              <span class="skeleton-line skeleton-shimmer" style="width: 40%; height: 12px;"></span>
            </div>
            <div class="skeleton-stats-row">
              <span class="skeleton-stat skeleton-shimmer"></span>
              <span class="skeleton-stat skeleton-shimmer"></span>
              <span class="skeleton-stat skeleton-shimmer"></span>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="my-fleet-card" *ngFor="let fleet of fleets" (click)="viewGroupForFind(fleet)">
        <!-- Photo at top -->
        <div class="card-photo">
          <img *ngIf="fleet.image_url" [src]="fleet.image_url" class="photo-img" />
          <div *ngIf="!fleet.image_url" class="photo-initials">
            {{ getInitials(fleet.name) }}
          </div>
          <!-- 3-dot menu overlaid top-right -->
          <button class="photo-menu-btn" [matMenuTriggerFor]="fleetMenu"
            (click)="$event.stopPropagation(); selectedFleetForMenu = fleet">
            <img src="assets/common_icons/threedots_icon.svg" />
          </button>
        </div>

        <!-- Card body -->
        <div class="card-body">
          <h3 class="fleet-name">{{ fleet.name }}</h3>
          <div class="fleet-org">
            <img class="org-icon" src="assets/home/profile/boaticon.svg" />
            {{ fleet.home_port || 'No vessel' }}
          </div>
          <div class="meta-row">
            <span class="member-count">{{ fleet.members_count }} {{ fleet.members_count <= 1 ? 'member' : 'members' }}</span>
            <span class="admin-badge" *ngIf="fleet.my_role === 'owner' || fleet.my_role === 'admin'">
              <mat-icon class="admin-icon">person</mat-icon>Admin
            </span>
          </div>

          <!-- Stats Row -->
          <div class="stats-row">
            <div class="stat-item">
              <span class="label">{{ (fleet.activity?.routes || 0) <= 1 ? 'Route' : 'Routes' }}</span>
              <span class="value">{{ fleet.activity?.routes || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="label">Fish Caught</span>
              <span class="value">{{ fleet.activity?.fish_caught || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="label">{{ (fleet.activity?.places || 0) <= 1 ? 'Place' : 'Places' }}</span>
              <span class="value">{{ fleet.activity?.places || 0 }}</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!loading && fleets.length === 0" class="no-data">
        {{ searchMyFleets ? 'No fleets match your search' : 'No fleets joined yet' }}
      </div>

      <!-- Skeleton: infinite scroll -->
      <div class="my-fleet-card skeleton-card" *ngIf="loading && fleets.length > 0">
        <div class="card-photo"></div>
        <div class="card-body">
          <span class="skeleton-line skeleton-shimmer" style="width: 65%; height: 18px;"></span>
          <span class="skeleton-line skeleton-shimmer" style="width: 45%; height: 12px; margin-top: 10px;"></span>
        </div>
      </div>
    </div>

    <!-- ============ Incoming Tab Content ============ -->
    <div class="fleets-list" [appTourAnchor]="'fleets.list'" *ngIf="activeTab === 'incoming'">

      <!-- Skeleton: initial load / search -->
      <ng-container *ngIf="(loading && fleets.length === 0) || searchLoading">
        <div class="incoming-fleet-card skeleton-card" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="top-row">
            <div class="header-info">
              <div class="user-avatar-main"></div>
              <div class="header-details">
                <span class="skeleton-line skeleton-shimmer" style="width: 55%; height: 16px;"></span>
                <span class="skeleton-line skeleton-shimmer" style="width: 40%; height: 12px; margin-top: 8px;"></span>
                <span class="skeleton-line skeleton-shimmer" style="width: 35%; height: 12px; margin-top: 8px;"></span>
              </div>
            </div>
          </div>
          <div class="skeleton-stats-row">
            <span class="skeleton-stat skeleton-shimmer"></span>
            <span class="skeleton-stat skeleton-shimmer"></span>
            <span class="skeleton-stat skeleton-shimmer"></span>
          </div>
          <div class="actions-buttons-large" style="margin-top: 12px;">
            <span class="skeleton-line skeleton-shimmer" style="width: 100%; height: 36px; border-radius: 8px;"></span>
            <span class="skeleton-line skeleton-shimmer" style="width: 100%; height: 36px; border-radius: 8px;"></span>
          </div>
        </div>
      </ng-container>

      <div class="incoming-fleet-card" *ngFor="let fleet of filteredFleets" (click)="viewGroup(fleet)">

        <!-- community_invite: Someone invited YOU to join their fleet -->
        <ng-container *ngIf="fleet.request_type === 'community_invite'">
          <div class="top-row">
            <div class="header-info">
              <!-- Left: Stacked avatars (requester over community) -->
              <div class="avatar-stack">
                <div class="avatar-community">
                  <img *ngIf="fleet.community_image_url" [src]="fleet.community_image_url" class="avatar-img" />
                  <div *ngIf="!fleet.community_image_url" class="avatar-placeholder">
                    {{ getInitials(fleet.name) }}
                  </div>
                </div>
              </div>

              <div class="header-details">
                <div class="title-row">
                  <span class="user-name-bold">{{ fleet.name }}</span>
                </div>

              <!-- <div class="subtitle-text">
              <img [src]="fleet.requester?.image_url" class="inline-avatar" *ngIf="fleet.requester?.image_url" />
              <span class="inline-avatar-placeholder" *ngIf="!fleet.requester?.image_url">{{ getInitials(fleet.requester?.name) }}</span>
              <span>{{ fleet.requester?.name }} invited you</span>
            </div> -->

              <div class="vessel-tag">
                <img src="assets/home/profile/boaticon.svg" class="vessel-tag-icon" />
                {{ fleet.home_port || 'No vessel' }}
              </div>
              <span class="member-count">{{ fleet.members_count }} {{ fleet.members_count === 1 ? 'member' : 'members' }}</span>
              </div>
            </div>
            <span class="time-ago">{{ getTimeAgo(fleet.requested_at) }}</span>
          </div>

        </ng-container>

        <!-- join_request: Someone wants to join YOUR fleet -->
        <ng-container *ngIf="fleet.request_type !== 'community_invite'">
          <div class="top-row">
            <div class="header-info">
              <div class="user-avatar-main">
                <img *ngIf="fleet.requester?.image_url" [src]="fleet.requester.image_url" class="avatar-img" />
                <div *ngIf="!fleet.requester?.image_url" class="avatar-placeholder">
                  {{ getInitials(fleet.requester?.name) }}
                </div>
              </div>

              <div class="header-details">
                <div class="title-row">
                  <span class="user-name-bold">{{ fleet.requester?.name }}</span>
                </div>

                <div class="subtitle-text">Wants to join {{ fleet.name }}</div>

                <div class="vessel-tag">
                  <img src="assets/home/profile/boaticon.svg" class="vessel-tag-icon" />
                  {{ (fleet.vessel_name && fleet.vessel_name !== 'No Vessel') ? fleet.vessel_name : 'No vessel' }}
                </div>
                <span class="member-count">{{ fleet.members_count }} {{ fleet.members_count === 1 ? 'member' : 'members' }}</span>
              </div>
            </div>
            <span class="time-ago">{{ getTimeAgo(fleet.requested_at) }}</span>
          </div>
        </ng-container>

             <!-- Stats -->
          <div class="stats-grid">
            <div class="stat-item">
              <span class="stat-label">{{ (fleet.activity?.routes || 0) <= 1 ? 'Route' : 'Routes' }}</span>
                  <span class="stat-value">{{ fleet.activity?.routes || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">Fish Caught</span>
              <span class="stat-value">{{ fleet.activity?.fish_caught || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">{{ (fleet.activity?.places || 0) <= 1 ? 'Place' : 'Places' }}</span>
                  <span class="stat-value">{{ fleet.activity?.places || 0 }}</span>
            </div>
          </div>

       

        <!-- Action Buttons -->
        <div class="actions-buttons-large">
          <button class="ignore-btn" (click)="rejectRequest(fleet , $event)" [disabled]="fleet.actionLoading">
            <span *ngIf="fleet.actionLoading && fleet.loadingAction === 'reject'" class="btn-spinner btn-spinner--dark"></span>
            <span *ngIf="!(fleet.actionLoading && fleet.loadingAction === 'reject')">Ignore</span>
          </button>
          <button class="accept-btn" (click)="acceptRequest(fleet , $event)" [disabled]="fleet.actionLoading">
            <span *ngIf="fleet.actionLoading && fleet.loadingAction === 'accept'" class="btn-spinner"></span>
            <span *ngIf="!(fleet.actionLoading && fleet.loadingAction === 'accept')">Accept</span>
          </button>
        </div>
      </div>

      <div *ngIf="!loading && filteredFleets.length === 0" class="no-data">
        {{ searchIncoming ? 'No incoming requests match your search' : 'No incoming requests' }}
      </div>

      <!-- Skeleton: infinite scroll -->
      <div class="incoming-fleet-card skeleton-card" *ngIf="loading && fleets.length > 0">
        <div class="top-row">
          <div class="header-info">
            <div class="user-avatar-main"></div>
            <div class="header-details">
              <span class="skeleton-line skeleton-shimmer" style="width: 55%; height: 16px;"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============ Sent Tab Content ============ -->
    <div class="fleets-list" [appTourAnchor]="'fleets.list'" *ngIf="activeTab === 'sent'">

      <!-- Skeleton: initial load / search -->
      <ng-container *ngIf="(loading && fleets.length === 0) || searchLoading">
        <div class="sent-fleet-card skeleton-card" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="top-row">
            <div class="header-info">
              <div class="avatar-section"></div>
              <div class="text-info">
                <span class="skeleton-line skeleton-shimmer" style="width: 55%; height: 16px;"></span>
                <span class="skeleton-line skeleton-shimmer" style="width: 40%; height: 12px; margin-top: 8px;"></span>
                <span class="skeleton-line skeleton-shimmer" style="width: 35%; height: 12px; margin-top: 8px;"></span>
              </div>
            </div>
          </div>
          <div class="skeleton-stats-row">
            <span class="skeleton-stat skeleton-shimmer"></span>
            <span class="skeleton-stat skeleton-shimmer"></span>
            <span class="skeleton-stat skeleton-shimmer"></span>
          </div>
          <div class="actions-buttons" style="margin-top: 12px;">
            <span class="skeleton-line skeleton-shimmer" style="width: 100%; height: 36px; border-radius: 8px;"></span>
          </div>
        </div>
      </ng-container>

      <div class="sent-fleet-card" *ngFor="let fleet of filteredFleets" (click)="viewGroup(fleet)">
        <div class="top-row">
          <div class="header-info">
            <div class="avatar-section">
              <img *ngIf="fleet.image_url" [src]="fleet.image_url" class="avatar-img" />
              <div *ngIf="!fleet.image_url" class="avatar-placeholder">
                {{ getInitials(fleet.name) }}
              </div>
            </div>
            <div class="text-info">
              <h3 class="fleet-name">{{ fleet.name }}</h3>
              <span class="subtitle" *ngIf="fleet.subtitle">{{ fleet.subtitle }}</span>

              <span class="members-count" *ngIf="fleet.members_count">{{ fleet.members_count }} {{ fleet.members_count === 1 ? 'Member' : 'Members' }}</span>

              <div class="vessel-tag">
                <img src="assets/home/profile/boaticon.svg" class="vessel-tag-icon" />
                {{ (fleet.vessel_name && fleet.vessel_name !== 'No Vessel') ? fleet.vessel_name : (fleet.home_port || 'No vessel') }}
              </div>

              <div class="mutual-connections">
                <div class="avatars-stack" *ngIf="(fleet.mutual_connection_count || 0) > 0">
                  <img *ngFor="let img of (fleet.mutual_connections_images || []).slice(0, 3)" [src]="img" />
                  <div class="more-badge" *ngIf="(fleet.mutual_connection_count || 0) > 3">+{{
                    (fleet.mutual_connection_count || 0) - 3 }}</div>
                </div>
                <img *ngIf="(fleet.mutual_connection_count || 0) === 0" src="assets/home/profile/no_mutual_icon.png"
                  class="placeholder" />
                <span>{{ fleet.mutual_connection_count || 0 }} Mutual {{ (fleet.mutual_connection_count || 0) === 1
                  ? 'Connection' : 'Connections' }}</span>
              </div>
            </div>
          </div>
          <span class="time-ago">{{ getTimeAgo(fleet.requested_at) }}</span>
        </div>

        <!-- Stats Grid -->
        <div class="stats-grid">
          <div class="stat-item">
            <span class="stat-label">{{ (fleet.activity?.routes || 0) <= 1 ? 'Route' : 'Routes' }}</span>
                <span class="stat-value">{{ fleet.activity?.routes || 0 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">Fish Caught</span>
            <span class="stat-value">{{ fleet.activity?.fish_caught || 0 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">{{ (fleet.activity?.places || 0) <= 1 ? 'Place' : 'Places' }}</span>
                <span class="stat-value">{{ fleet.activity?.places || 0 }}</span>
          </div>
        </div>

        <!-- Buttons -->
        <div class="actions-buttons">
          <button class="decline-btn" (click)="$event.stopPropagation(); cancelRequest(fleet)"
            [disabled]="fleet.actionLoading">
            <span *ngIf="fleet.actionLoading" class="btn-spinner btn-spinner--dark"></span>
            <span *ngIf="!fleet.actionLoading">Cancel Request</span>
          </button>
        </div>
      </div>

      <div *ngIf="!loading && filteredFleets.length === 0" class="no-data">
        <ng-container *ngIf="searchSent; else noSentDefault">
          No sent requests match your search
        </ng-container>
        <ng-template #noSentDefault>
          <span class="no-data-text">No sent fleet requests</span>
          <span class="no-data-sub">Sent fleet requests will appear here</span>
        </ng-template>
      </div>

      <!-- Skeleton: infinite scroll -->
      <div class="sent-fleet-card skeleton-card" *ngIf="loading && fleets.length > 0">
        <div class="top-row">
          <div class="header-info">
            <div class="avatar-section"></div>
            <div class="text-info">
              <span class="skeleton-line skeleton-shimmer" style="width: 55%; height: 16px;"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Fleet Detail Popup -->
  <ng-container *ngIf="showFleetOvelay">
    <!-- Loader while fetching fleet data -->
    <div *ngIf="loadingDetail" class="fleet-detail-loader-overlay" (click)="closeDetail()">
      <div class="fleet-detail-loader-sheet" (click)="$event.stopPropagation()">
        <app-loader [loading]="true" [overlay]="false"></app-loader>
      </div>
    </div>
    <!-- Fleet detail renders only once full data is ready -->
    <app-fleet-detail
      *ngIf="selectedFleet && !loadingDetail"
      [fleet]="selectedFleet"
      [hideActivity]="false"
      (close)="closeDetail()">
    </app-fleet-detail>
  </ng-container>

  <!-- Create Fleet Popup -->
  <app-create-fleet *ngIf="showCreateFleet" [editFleet]="editFleetData" (close)="closeCreateFleet()"
    (saved)="onFleetSaved($event)"></app-create-fleet>

  <!-- Manage Members Popup -->
  <!-- Owners/admins get the manage view; everyone else gets the read-only roster
       with an Owner/Admin badge, and every row opens that captain's profile.
       This instance was missing BOTH bindings, so opening the roster from the
       Fleets tab still handed a plain member the full manage-members screen with
       inert rows — the fleet-detail copy was fixed, this one was not. -->
  <app-manage-members *ngIf="showManageMembers" [fleet]="selectedFleetForMenu"
    [readOnly]="!canManageSelectedFleet"
    (memberSelected)="onMemberSelected($event)"
    (close)="closeManageMembers()"></app-manage-members>

  <!-- Fleet Menu -->
  <mat-menu #fleetMenu="matMenu" class="fleet-custom-menu">
    <ng-container *ngIf="selectedFleetForMenu?.my_role === 'owner'">
      <button mat-menu-item (click)="editFleetMenu()" class="custom-menu-item">
        <img src="assets/common_icons/fleet_edit.svg" class="menu-icon" />
        <span class="label">Edit Fleet</span>
      </button>

      <button mat-menu-item (click)="toggleRestrictiveMenu()" class="custom-menu-item restrictive-menu-item">
        <svg class="menu-icon-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          fill="none" stroke="#B25A00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        <div class="restrictive-content">
          <span class="r-label">Restrictive Sharing</span>
          <span class="r-sub">{{ selectedFleetForMenu?.is_restrictive ? 'On' : 'Off' }}</span>
        </div>
        <div class="ios-toggle" [class.ios-toggle-on]="selectedFleetForMenu?.is_restrictive">
          <div class="ios-thumb"></div>
        </div>
      </button>

      <button mat-menu-item (click)="fleetGeofenceMenu()" class="custom-menu-item">
        <img src="assets/common_icons/fleet_geoloc.svg" class="menu-icon" />
        <span class="label">Fleet Geofence</span>
      </button>

      <button mat-menu-item (click)="manageMembersMenu()" class="custom-menu-item">
        <img src="assets/common_icons/fleet_manage.svg" class="menu-icon" />
        <span class="label">Manage Members</span>
      </button>

      <button mat-menu-item (click)="deleteFleet()" class="custom-menu-item delete">
        <img src="assets/common_icons/delete_fleet.svg" class="menu-icon" />
        <span class="label">Delete Fleet</span>
      </button>
    </ng-container>

    <!-- Member Actions -->
    <button *ngIf="selectedFleetForMenu?.my_role !== 'owner'" mat-menu-item (click)="leaveFleet()"
      class="custom-menu-item delete">
      <img src="assets/common_icons/fleet_leave.svg" class="menu-icon" />
      <span class="label">Leave Fleet</span>
    </button>
  </mat-menu>
  <!-- Leave Fleet Confirm Modal -->
  <div class="leave-confirm-overlay" *ngIf="showLeaveConfirm" (click)="showLeaveConfirm = false">
    <div class="leave-confirm-modal" (click)="$event.stopPropagation()">
      <h3 class="modal-title">Leave Fleet</h3>
      <p class="modal-message">Are you sure you want to leave this fleet?</p>
      <div class="modal-actions">
        <button class="modal-cancel-btn" (click)="showLeaveConfirm = false" [disabled]="confirmActionLoading">Cancel</button>
        <button class="modal-leave-btn" (click)="confirmLeave()" [disabled]="confirmActionLoading">
          <span *ngIf="confirmActionLoading" class="btn-spinner"></span>
          <span *ngIf="!confirmActionLoading">Leave</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Delete Fleet Confirm Modal -->
  <div class="leave-confirm-overlay" *ngIf="showDeleteConfirm" (click)="showDeleteConfirm = false">
    <div class="leave-confirm-modal" (click)="$event.stopPropagation()">
      <h3 class="modal-title">Delete Fleet</h3>
      <p class="modal-message">Are you sure you want to delete this fleet? This action cannot be undone.</p>
      <div class="modal-actions">
        <button class="modal-cancel-btn" (click)="showDeleteConfirm = false" [disabled]="confirmActionLoading">Cancel</button>
        <button class="modal-leave-btn" (click)="confirmDelete()" [disabled]="confirmActionLoading">
          <span *ngIf="confirmActionLoading" class="btn-spinner"></span>
          <span *ngIf="!confirmActionLoading">Delete</span>
        </button>
      </div>
    </div>
  </div>

</div>

<app-restrictive-acknowledgement-dialog
  *ngIf="showFleetRestrictiveDialog"
  mode="agreement"
  (agreed)="onFleetRestrictiveAgreed()"
  (disagreed)="onFleetRestrictiveDisagreed()"
  (closed)="onFleetRestrictiveDisagreed()">
</app-restrictive-acknowledgement-dialog>

<app-restrictive-acknowledgement-dialog
  *ngIf="showJoinRestrictiveDialog"
  mode="agreement"
  (agreed)="onJoinRestrictiveAgreed()"
  (disagreed)="onJoinRestrictiveDisagreed()"
  (closed)="onJoinRestrictiveDisagreed()">
</app-restrictive-acknowledgement-dialog>